import { V2 } from '../../../theme/tokens'
import { Box } from '@mui/material'

/**
 * TimelineIcon — 28x28 circle wrapping a child icon for ActivityTimeline.
 *
 * @description
 *   Consistent icon-circle style for every ActivityTimeline entry. Consumers
 *   supply the inner `<Icon>` + palette (`bg`, `border`) keyed off their own
 *   type map so each domain owns its visual vocabulary.
 *
 * @useWhen
 *   - Rendering the dot inside an ActivityTimeline TimelineSeparator
 *   - Any circular-icon badge on a list row (meetings, status markers)
 *
 * @dontUseFor
 *   - Standalone avatar → use MUI `<Avatar>`
 *   - Status chip with text → use MUI `<Chip>` or domain StatusChip
 *
 * @related
 *   - ActivityTimeline — host component that places these in TimelineSeparator
 *
 * @reuseHints
 *   - Could back list-row icons in InboxRow when the type palette is domain-keyed
 *   - Works as a dot marker in a vertical stepper
 *
 * @props
 *   - icon — ReactNode; the MUI Icon component already sized/coloured
 *   - bg, border — palette colours (hex or token); defaults to subtle grey
 *   - size — circle diameter in px (default 28)
 */
export default function TimelineIcon({ icon, bg = V2.wash, border = V2.ink45, size = 28 }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        border: '1.5px solid',
        borderColor: border,
        bgcolor: bg,
      }}
    >
      {icon}
    </Box>
  )
}
